export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-good-en.6d3f7283.svg";